// Ring buffer of the last N failed API responses (non-2xx), for the crash
// report: which request failed just before it broke. In memory, like breadcrumbs.
const MAX = 10;
const failures = [];

export const recordApiFailure = ({ url, status, statusText }) => {
  failures.push({ url, status, statusText, ts: new Date().toISOString() });
  if (failures.length > MAX) failures.shift();
};

export const getApiFailures = () => failures.slice();
